import { api } from "../@vendor/utils";
import { createCancelTokenHandler } from "../@vendor/utils/services/cancel-token.service";
import { AxiosPromise } from "axios";

const endPoint = () => window._env_.REACT_APP_PASSPORT_END_POINT;

export interface GuestBookingPayload {
  name: string;
  email: string;
  phone_number: string;
  phone_country: string;
  date_of_birth: string;
  payment_method_id: number;
  bookings: {
    schedule_id?: number; // Optional untuk assessment tanpa schedule
    category_id?: number;
    duration?: number; // Optional untuk assessment tanpa schedule
    price: number;
    assessment_id?: number;
    session_amount?: number;
    is_package?: boolean;
  }[];
  // for credit card
  xendit_token_id?: string;
  xendit_authentication_id?: string;
  xendit_card_cvn?: string;
  card_holder_email?: string;
  card_holder_first_name?: string;
  card_holder_last_name?: string;
  card_holder_phone_number?: string;
}

interface IGuestBookingRepository {
  createAssessment(payload: GuestBookingPayload): AxiosPromise<any>;
}

const GuestBookingRepository: IGuestBookingRepository = {
  createAssessment(payload) {
    return api.post(`${endPoint()}/api/booking-assessment`, payload, {
      cancelToken:
        cancelTokenHandlerObject[this.createAssessment.name].handleRequestCancellation()
          .token,
    });
  },
};

const cancelTokenHandlerObject = createCancelTokenHandler(GuestBookingRepository);

export default GuestBookingRepository;